import axios from "axios";
const CWE_TAG_DATA_PATH = "https://static-assets.securityjourney.com/cwe-data.json";

export const getCweTags = async () => {
  try {
    const result = await axios.get(CWE_TAG_DATA_PATH);
    return result.data;
  } catch (error) {
    console.error("Error fetching CWE tag data", error);
  }
};
